import { styled, Toolbar, Tabs } from '@mui/material';

const ToolbarStyled = styled(Toolbar)(({ theme }) => ({
  backgroundColor: theme.palette.grey[200],
  padding: 0,
  [theme.breakpoints.up('md')]: {
    minHeight: 0,
    padding: 0
  }
}));

const prefix = 'HusaFormTabs';
const formTabsClasses = {
  tabs: `${prefix}-tabs`,
  tabIndicator: `${prefix}-tabIndicator`,
  tabLabel: `${prefix}-tabLabel`
};
const FormTabsStyled = styled(Tabs)(({ theme }) => ({
  [`& .${formTabsClasses.tabs}`]: {
    borderTop: `1px solid ${theme.palette.grey[200]}`
  },
  [`& .${formTabsClasses.tabIndicator}`]: {
    display: 'none'
  },
  [`& .${formTabsClasses.tabLabel}`]: {
    textTransform: 'none',
    fontSize: '18px',
    '&.Mui-selected': {
      backgroundColor: theme.palette.primary.main,
      color: '#fff'
    }
  }
}));

const TabContentStyled = styled('div')(() => ({
  paddingTop: 0
}));

export { ToolbarStyled, FormTabsStyled, formTabsClasses, TabContentStyled };
